import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";
import spectrophotometerObjects from "./spectrophotometerSimObjectDefinition";
import enzymeObjects from "./enzymeSimObjectDefinitions";
import eggLabObjects from "./egglabSimObjectDefinations";
import mitosisObjects from "./mitosisObjectDefinitions";
import microscopeObjects from "./microscopeSimObjectDefinitions";
import cryObjects from "./crySimObjectDefinitions";
import energyDynamicsObjects from "./energyDynamicsSimObject";

const objects: ObjectDefinitions[] = [
  ...spectrophotometerObjects,
  ...eggLabObjects,
  ...enzymeObjects,
  ...mitosisObjects,
  ...microscopeObjects,
  ...cryObjects,
  ...energyDynamicsObjects,
  {
    name: "Table",
    image: "table",
    type: "sceneObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "table",
      },
    ],
  },
  {
    name: "shelf",
    image: "shelf",
    type: "sceneObject",
  },
  {
    name: "tube_rack_large",
    image: "tube_rack_large",
    type: "sceneObject",
  },
  {
    name: "pipette_rack_m",
    image: "pipette_rack_m",
    type: "sceneObject",
  },
  {
    name: "trash",
    image: "TrashIcon",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "TrashIcon",
        altText: "Trash",
      },
    ],
  },
  {
    name: "ice_bucket",
    image: "ice_bucket",
    type: "sceneObject",
  },
  {
    name: "test_tube",
    image: "test_tube",
    type: "interactableObject",
    buttons: [
      {
        title: "Move the Test Tube",
        icon: "MCEjectTubeIcon",
        type: "Action",
        actionName: "MOVE_TEST_TUBE",
      },
    ],
    states: [
      {
        name: "ClosedEmpty",
        image: "empty_closed_plastic_tube",
        altText: "Plastic tube is closed and empty.",
        buttons: [
          {
            title: "Open",
            icon: "open_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenEmpty",
              },
            ],
          },
        ],
      },
      {
        name: "OpenEmpty",
        image: "empty_opened_plastic_tube",
        altText: "Plastic tube is open and empty.",
        buttons: [
          {
            title: "Close",
            icon: "close_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedEmpty",
              },
            ],
          },
        ],
      },
      {
        name: "ClosedTiny",
        image: "tiny_closed_plastic_tube",
        altText: "Plastic tube is closed and has a tiny amount of liquid.",
        buttons: [
          {
            title: "Open",
            icon: "open_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenTiny",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenTiny",
        image: "tiny_opened_plastic_tube",
        altText: "Plastic tube is open and has a tiny amount of liquid.",
        buttons: [
          {
            title: "Open",
            icon: "close_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedTiny",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "ClosedHalf",
        image: "half_closed_plastic_tube",
        altText: "Plastic tube is closed and filled halfway with liquid.",
        buttons: [
          {
            title: "Open",
            icon: "open_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenHalf",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenHalf",
        image: "half_opened_plastic_tube",
        altText: "Plastic tube is open and filled halfway with liquid.",
        buttons: [
          {
            title: "Open",
            icon: "close_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedHalf",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenFull",
        image: "full_opened_plastic_tube",
        altText: "Plastic tube is open and completely filled with liquid.",
        buttons: [
          {
            title: "Close",
            icon: "close_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedFull",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "ClosedFull",
        image: "full_closed_plastic_tube",
        altText: "Plastic tube is closed and completely filled with liquid.",
        buttons: [
          {
            title: "Open",
            icon: "open_door",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenFull",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
    ],
  },
  {
    name: "test_tube_null",
    image: "test_tube",
    type: "interactableObject",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "ClosedFull",
        image: "test_tube_full",
        altText: "Plastic tube is closed and completely filled with liquid.",
      },
    ],
  },
  {
    name: "photosynthesis_poster",
    image: "pHScalePosterIcon",
    type: "interactableObject",
  },
  {
    name: "plantTank",
    image: "PlantTankIcon",
    type: "sceneObject",
  },
  {
    name: "stopper",
    image: "StopperIcon",
    type: "controllableObject",
  },
  {
    name: "lid",
    image: "CuvetteLidIcon",
    type: "controllableObject",
  },
  {
    name: "plant",
    image: "PlantIcon",
    type: "controllableObject",
    states: [
      {
        name: "showing",
        image: "PlantIcon",
      },
      {
        name: "hidden",
        image: "CloseIcon",
      },
    ],
  },
  {
    name: "Box",
    image: "BoxIcon",
    type: "controllableObject",
  },
  {
    name: "Light",
    image: "LightOffIcon",
    type: "interactableObject",
    defaultState: "Off",
    states: [
      {
        name: "Off",
        image: "LightOffIcon",
      },
      {
        name: "On",
        image: "LightOnIcon",
      },
    ],
  },
  {
    name: "Micropipette",
    image: "PipetteVectorIcon",
    type: "controllableObject",
  },
  {
    name: "P1000TipBox",
    image: "P1000_TipBox_Closed",
    type: "interactableObject",
    states: [
      {
        name: "Open",
        image: "P1000_TipBox_Open",
        altText: "P1000 Tip Box is open.",
      },
      {
        name: "Closed",
        image: "P1000_TipBox_Closed",
        altText: "P1000 Tip Box is closed.",
      },
    ],
  },
  {
    name: "P200TipBox",
    image: "P200_TipBox_Closed",
    type: "interactableObject",
    states: [
      {
        name: "Open",
        image: "P200_TipBox_Open",
        altText: "P200 Tip Box is open.",
      },
      {
        name: "Closed",
        image: "P200_TipBox_Closed",
        altText: "P200 Tip Box is closed.",
      },
    ],
  },
  {
    name: "P20TipBox",
    image: "P20_TipBox_Closed",
    type: "interactableObject",
    states: [
      {
        name: "Open",
        image: "P20_TipBox_Open",
        altText: "P20 Tip Box is open.",
      },
      {
        name: "Closed",
        image: "P20_TipBox_Closed",
        altText: "P20 Tip Box is closed.",
      },
    ],
  },
  {
    name: "P2TipBox",
    image: "P2_TipBox_Closed",
    type: "interactableObject",
    states: [
      {
        name: "Open",
        image: "P2_TipBox_Open",
        altText: "P2 Tip Box is open.",
      },
      {
        name: "Closed",
        image: "P2_TipBox_Closed",
        altText: "P2 Tip Box is closed.",
      },
    ],
  },
  {
    name: "GlassTube",
    image: "BoxIcon",
    type: "interactableObject",
    states: [
      {
        name: "empty",
        image: "BoxIcon",
      },
      {
        name: "plant",
        image: "BoxIcon",
      },
      {
        name: "processed",
        image: "BoxIcon",
      },
    ],
  },
  {
    name: "beaker_large_0",
    image: "beaker_large_6Tubes",
    type: "interactableObject",
    defaultState: "6Tubes",
    buttons: [
      {
        title: "Eject button",
        icon: "eject_button",
        type: "Eject",
        itemId: "beaker_large_0",
      },
    ],
    states: [
      {
        name: "Disabled",
        image: "beaker_large_disabled",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "6/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText:
          "Beaker containing 6 0.0 M dialysis tubes. This beaker is not able to be used in your protocol.",
      },
      {
        name: "6Tubes",
        image: "beaker_large_6Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "6/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 6 0.0 M dialysis tubes",
      },
      {
        name: "5Tubes",
        image: "beaker_large_5Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "5/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 5 0.0 M dialysis tubes",
      },
      {
        name: "4Tubes",
        image: "beaker_large_4Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "4/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 4 0.0 M dialysis tubes",
      },
      {
        name: "3Tubes",
        image: "beaker_large_3Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "3/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 3 0.0 M dialysis tubes",
      },
      {
        name: "2Tubes",
        image: "beaker_large_2Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "2/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 2 0.0 M dialysis tubes",
      },
      {
        name: "1Tube",
        image: "beaker_large_1Tube",
        label: {
          topLine: {
            text: "Dialysis tubes with 0.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 1 0.0 M dialysis tubes",
      },
      {
        name: "Empty",
        image: "beaker_large_Empty",
        label: {
          text: "Empty Beaker",
          offset: -80,
        },
        altText: "Beaker containing 0 0.0 M dialysis tubes",
      },
    ],
  },
  {
    name: "beaker_large_1",
    image: "beaker_large_6Tubes",
    type: "interactableObject",
    defaultState: "6Tubes",
    buttons: [
      {
        title: "Eject button",
        icon: "eject_button",
        type: "Eject",
        itemId: "beaker_large_1",
      },
    ],
    states: [
      {
        name: "Disabled",
        image: "beaker_large_disabled",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "6/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText:
          "Beaker containing 6 1.0 M dialysis tubes. This beaker is not able to be used in your protocol.",
      },
      {
        name: "6Tubes",
        image: "beaker_large_6Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "6/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 6 1.0 M dialysis tubes.",
      },
      {
        name: "5Tubes",
        image: "beaker_large_5Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "5/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 5 1.0 M dialysis tubes.",
      },
      {
        name: "4Tubes",
        image: "beaker_large_4Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "4/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 4 1.0 M dialysis tubes.",
      },
      {
        name: "3Tubes",
        image: "beaker_large_3Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "3/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 3 1.0 M dialysis tubes.",
      },
      {
        name: "2Tubes",
        image: "beaker_large_2Tubes",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "2/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 2 1.0 M dialysis tubes.",
      },
      {
        name: "1Tube",
        image: "beaker_large_1Tube",
        label: {
          topLine: {
            text: "Dialysis tubes with 1.0 M",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/6 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker containing 1 1.0 M dialysis tubes.",
      },
      {
        name: "Empty",
        image: "beaker_large_Empty",
        label: {
          text: "Empty Beaker",
          offset: -80,
        },
        altText: "Beaker containing 0 1.0 M dialysis tubes.",
      },
    ],
  },
  {
    name: "tube",
    image: "tube_wet",
    type: "controllableObject",
    defaultState: "wet",
    defaultUserInput: {
      tube_number: 0,
      beaker_number: 0,
      weight: 0,
    },
    states: [
      {
        name: "wet",
        image: "tube_wet",
      },
      {
        name: "dry",
        image: "tube_dry",
      },
      {
        name: "wet_solution",
        image: "tube_wet_solution",
      },
      {
        name: "dry_solution",
        image: "tube_dry_solution",
      },
    ],
  },
  {
    name: "tissue_roll",
    image: "tissue_roll",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "tissue_roll",
        altText: "Roll of paper towel",
      },
    ],
  },
  {
    name: "tissue_paper",
    image: "",
    type: "controllableObject",
    defaultState: "hidden",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "dry",
        image: "tissue_paper_dry",
        moveMenu: ["Trash"],
        altText: "Dry sheet of paper towel",
      },
      {
        name: "wet",
        image: "tissue_paper_wet",
        moveMenu: ["Trash"],
        altText: "Wet sheet of paper towel",
      },
      {
        name: "trashed",
        image: "",
      },
    ],
  },
  {
    name: "osmosis_poster",
    image: "osmosis_poster",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "osmosis_poster",
        altText: "Lab goal poster",
      },
    ],
  },
  {
    name: "beakerA",
    image: "beaker_empty_A",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker A containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerA",
          },
        ],
        altText: "Beaker A containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker A",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker A containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beakerB",
    image: "beaker_empty_B",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker B containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerB",
          },
        ],
        altText: "Beaker B containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker B",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker B containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beakerC",
    image: "beaker_empty_C",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker C containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerC",
          },
        ],
        altText: "Beaker C containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker C",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker C containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beakerD",
    image: "beaker_empty_D",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker D containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerD",
          },
        ],
        altText: "Beaker D containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker D",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker D containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beakerE",
    image: "beaker_empty_E",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker E containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerE",
          },
        ],
        altText: "Beaker E containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker E",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker E containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beakerF",
    image: "beaker_empty_F",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker F containing 0/1 dialysis tubes",
      },
      {
        name: "Filled_1",
        image: "small_beaker_tube_1",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_2",
        image: "small_beaker_tube_2",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_3",
        image: "small_beaker_tube_3",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_4",
        image: "small_beaker_tube_4",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_5",
        image: "small_beaker_tube_5",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Filled_6",
        image: "small_beaker_tube_6",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "1/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "beakerF",
          },
        ],
        altText: "Beaker F containing 1/1 dialysis tubes",
      },
      {
        name: "Used",
        image: "beaker_Empty",
        label: {
          topLine: {
            text: "Beaker F",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/1 Dialysis tubes",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          direction: "horizontal",
          offset: -80,
        },
        altText: "Beaker F containing 0/1 dialysis tubes",
      },
    ],
  },
  {
    name: "beaker_1",
    image: "beaker_1",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_1",
      },
    ],
  },
  {
    name: "beaker_2",
    image: "beaker_2",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_2",
      },
      {
        name: "Tube",
        image: "beaker_tube_B",
      },
    ],
  },
  {
    name: "beaker_3",
    image: "beaker_3",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_3",
      },
      {
        name: "Tube",
        image: "beaker_tube_C",
      },
    ],
  },
  {
    name: "beaker_4",
    image: "beaker_4",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_4",
      },
      {
        name: "Tube",
        image: "beaker_tube_D",
      },
    ],
  },
  {
    name: "beaker_5",
    image: "beaker_5",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_5",
      },
      {
        name: "Tube",
        image: "beaker_tube_E",
      },
    ],
  },
  {
    name: "beaker_6",
    image: "beaker_6",
    type: "interactableObject",
    states: [
      {
        name: "Emtpy",
        image: "beaker_6",
      },
      {
        name: "Tube",
        image: "beaker_tube_F",
      },
    ],
  },
  {
    name: "OverviewModal",
    image: "",
    type: "interactableObject",
    defaultState: "showModal",
    states: [
      {
        name: "showModal",
        image: "",
      },
      {
        name: "NoModal",
        image: "",
      },
    ],
  },
  {
    name: "timer",
    image: "timerIcon",
    type: "interactableObject",
    defaultState: "notSet",
    states: [
      {
        name: "notSet",
        image: "timerIcon",
        altText: "Timer",
      },
      {
        name: "set",
        image: "timerIcon",
        altText: "Timer",
      },
    ],
  },
  {
    name: "balance_scale",
    image: "scale_empty",
    type: "interactableObject",
    defaultState: "error",
    defaultUserInput: { error: 5, current_weight: 5 },
    buttons: [
      {
        icon: "ConfigApparatusIcon",
        title: "Scale settings",
        type: "Modal",
        modal: "ElectronicScale",
      },
    ],
    states: [
      {
        name: "error",
        image: "scale_empty",
        label: {
          text: "Electronic balance",
          offset: -80,
        },

        altText:
          "Electronic balance with 0 dialysis tube on it. The screen shows ",
      },
      {
        name: "zero",
        image: "scale_empty",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        altText:
          "Electronic balance with 0 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_1",
        image: "scale_1tube_1",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_2",
        image: "scale_1tube_2",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_3",
        image: "scale_1tube_3",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_4",
        image: "scale_1tube_4",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_5",
        image: "scale_1tube_5",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_6",
        image: "scale_1tube_6",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_2tubes_1",
        image: "scale_2tubes_1",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_2",
        image: "scale_2tubes_2",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_3",
        image: "scale_2tubes_3",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_4",
        image: "scale_2tubes_4",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_5",
        image: "scale_2tubes_5",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_6",
        image: "scale_2tubes_6",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_1",
        image: "scale_3tubes_1",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_2",
        image: "scale_3tubes_2",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_3",
        image: "scale_3tubes_3",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_4",
        image: "scale_3tubes_4",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_5",
        image: "scale_3tubes_5",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_6",
        image: "scale_3tubes_6",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      //Wet

      {
        name: "scale_1tube_1_wet",
        image: "scale_1tube_1_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_2_wet",
        image: "scale_1tube_2_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_3_wet",
        image: "scale_1tube_3_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_4_wet",
        image: "scale_1tube_4_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_5_wet",
        image: "scale_1tube_5_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_1tube_6_wet",
        image: "scale_1tube_6_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 1 dialysis tube on it. The screen shows ",
      },
      {
        name: "scale_2tubes_1_wet",
        image: "scale_2tubes_1_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_2_wet",
        image: "scale_2tubes_2_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_3_wet",
        image: "scale_2tubes_3_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_4_wet",
        image: "scale_2tubes_4_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_5_wet",
        image: "scale_2tubes_5_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_2tubes_6_wet",
        image: "scale_2tubes_6_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 2 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_1_wet",
        image: "scale_3tubes_1_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_2_wet",
        image: "scale_3tubes_2_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_3_wet",
        image: "scale_3tubes_3_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_4_wet",
        image: "scale_3tubes_4_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_5_wet",
        image: "scale_3tubes_5_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
      {
        name: "scale_3tubes_6_wet",
        image: "scale_3tubes_6_wet",
        label: {
          text: "Electronic balance",
          offset: -80,
        },
        buttons: [
          {
            title: "Eject button",
            icon: "eject_button",
            type: "Eject",
            itemId: "balance_scale",
          },
        ],
        altText:
          "Electronic balance with 3 dialysis tubes on it. The screen shows ",
      },
    ],
  },
  {
    name: "tube_1",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
        moveMenu: ["Scale"],
      },
      {
        name: "wet",
        image: "tube1_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube1_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube1_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube1_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "tube_2",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
      },
      {
        name: "wet",
        image: "tube2_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube2_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube2_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube2_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "tube_3",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
      },
      {
        name: "wet",
        image: "tube3_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube3_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube3_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube3_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "tube_4",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
      },
      {
        name: "wet",
        image: "tube4_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube4_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube4_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube4_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "tube_5",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
      },
      {
        name: "wet",
        image: "tube5_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube5_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube5_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube5_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "tube_6",
    image: "",
    type: "controllableObject",
    defaultState: "largeBeaker",
    states: [
      {
        name: "largeBeaker",
        image: "",
      },
      {
        name: "wet",
        image: "tube6_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry",
        image: "tube6_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_solution",
        image: "tube6_wet",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_solution",
        image: "tube6_dry",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "dry_onScale_Solution",
        image: "",
        moveMenu: [
          "Scale",
          "Trash",
          "Beaker1",
          "Beaker2",
          "Beaker3",
          "Beaker4",
          "Beaker5",
          "Beaker6",
        ],
      },
      {
        name: "wet_onScale_Solution",
        image: "",
      },
      {
        name: "beaker",
        image: "",
      },
      {
        name: "discarded",
        image: "",
      },
    ],
  },
  {
    name: "light_switch",
    image: "LightSwitchOn",
    type: "interactableObject",
    defaultState: "on",
    states: [
      {
        name: "on",
        image: "LightSwitchOn",
      },
      {
        name: "off",
        image: "LightSwitchOff",
      },
    ],
  },
  {
    name: "light_bulb",
    image: "",
    type: "interactableObject",
    defaultState: "on",
    states: [
      {
        name: "on",
        image: "LightBulbOn",
      },
      {
        name: "off",
        image: "LightBulbOff",
      },
    ],
  },
  {
    name: "notebook",
    image: "Notebook",
    type: "interactableObject",
  },
  {
    name: "pipette",
    image: "",
    type: "customObject",
  },
  {
    name: "modal",
    image: "",
    type: "interactableObject",
  },
  {
    name: "tube_rack_small",
    image: "tube_rack_small",
    type: "sceneObject",
  },
  {
    name: "calendar",
    image: "CalendarZeroDays",
    type: "interactableObject",
    states: [
      {
        name: "calendar_0_days",
        image: "CalendarZeroDays",
        label: {
          topLine: {
            text: "Calendar",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "Day 0/21",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "calendar_7_days",
        image: "CalendarSevenDays",
        label: {
          topLine: {
            text: "Calendar",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "Day 7/21",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "calendar_14_days",
        image: "CalendarFourteenDays",
        label: {
          topLine: {
            text: "Calendar",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "Day 14/21",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "calendar_21_days",
        image: "CalendarTwentyOneDays",
        label: {
          topLine: {
            text: "Calendar",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "Day 21/21",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
    ],
  },
];

export default objects;
